import { OPTION } from '@/apps/open/types'

export enum EAppType {
  WEB = 1,
  MOBILE = 5,
  PC = 4,
  APPLET = 6,
  OTHER = 7
}

export const APP_TYPE_OPTIONS: OPTION[] = [
  { label: '网页应用', value: EAppType.WEB },
  { label: '移动应用', value: EAppType.MOBILE },
  { label: 'PC应用', value: EAppType.PC },
  { label: '小程序', value: EAppType.APPLET },
  { label: '其他', value: EAppType.OTHER }
]
